import type { MantineBreakpoint } from "@mantine/core";
import { useMediaQuery } from "@mantine/hooks";

const sizes: Record<MantineBreakpoint, string> = {
	xs: "36em",
	sm: "48em",
	md: "62em",
	lg: "75em",
	xl: "88em",
};

export function useBreakpoint(size: MantineBreakpoint, initial = false) {
	return useMediaQuery(`(max-width: ${sizes[size]})`, initial);
}
